import Config from './Config';


import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';

export default class ProjectsPage {

    constructor() {

        if($(window).width() > 768){

            $('.projects-slider').bxSlider({
                minSlides: $(window).width() > 768 ? 3 : 1,
                maxSlides: $(window).width() > 768 ? 3 : 1,
                slideWidth: $(window).width() > 768 ? $(window).width() / 3 : $(window).width(),
                slideMargin: 10,
                moveSlides: 1,
                pager: false,
                infiniteLoop: false,
                hideControlOnEnd: true
            })

        }
    }

}



// WEBPACK FOOTER //
// src/scripts/ProjectsPage.js